import type { Match } from 'found';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import type { AsyncActionStatus } from '../actions/common.actionTypes';
import CuratedCollections from '../components/CuratedCollections';
import type { StoreType } from '../reducers';
import { selectCuratedCollections } from '../reducers/collections.selectors';
import type { CollectionProperties } from '../types/AppContent';

interface StateProps {
	curatedCollections: CollectionProperties[];
	collectionStatus: AsyncActionStatus;
}

type CuratedCollectionListPageProps = StateProps & Match;

const CuratedCollectionListPage: React.FC<CuratedCollectionListPageProps> = ({
	curatedCollections,
	collectionStatus,
}) => {
	return (
		<CuratedCollections
			curatedCollections={curatedCollections}
			collectionsStatus={collectionStatus}
		/>
	);
};

const mapState = (state: StoreType): StateProps => ({
	curatedCollections: selectCuratedCollections(state),
	collectionStatus: state.collections.curated.status,
});

export default compose<React.FC<Record<string, never>>>(connect(mapState))(
	CuratedCollectionListPage
);
